import { NavLink } from 'fluxible-router';
import React from 'react';
import StickyPopover from '../StickyPopover';
import styles from './styles.module.styl';
export var DefinitionTooltip = function (_a) {
    var children = _a.children, dataKey = _a.dataKey, _b = _a.term, term = _b === void 0 ? {
        title: '',
        definition: '',
    } : _b;
    if (!term) {
        return React.createElement("span", { dangerouslySetInnerHTML: { __html: children } });
    }
    var title = term.title, definition = term.definition, short = term.short;
    return (React.createElement(StickyPopover, { onMouseEnter: function () { return null; }, title: title, classOverride: styles.popover, popover: React.createElement("div", null,
            React.createElement("p", { dangerouslySetInnerHTML: { __html: short || definition } }),
            React.createElement(NavLink, { href: "/docs/glossary?term=".concat(dataKey), className: styles.glossaryLink }, "View Glossary")) },
        React.createElement("span", { className: styles.underlinedWord, dangerouslySetInnerHTML: { __html: children } })));
};
